<template>
	<div class="container-wrapper">
		<div class="news-banner">
		</div>
		<!--<div class="news-container">-->
		<!--<div class="news-container-item">-->
		<!--<div class="item-container">-->
		<!--<img src="../../assets/img/news/news4.jpg" alt="">-->
		<!--<div class="text-container" @click="openItem(4)">-->
		<!--<div class="text-container-left">-->
		<!--<img src="../../components/contact/image/H..png" alt="">-->
		<!--</div>-->
		<!--<div class="text-container-right">-->
		<!--<p>华视美达亮相Hotel Plus2019</p>-->
		<!--<p style="color: #7f7f7f">2019-03-01</p>-->
		<!--</div>-->
		<!--<div class="text-container-down">-->
		<!--<p>2019年4月25-27日，华视美达亮相上海国际酒店工<br/>程设计与用品博览会，本次华视美达主要展示小美AI场景<br/>机器人、华视云朵&点播分成平台以及9款UI和50多款应<br/>用自由搭配组合等，受到行业的同仁们的关注和肯定！-->
		<!--</p>-->
		<!--</div>-->
		<!--<div class="icon-more">-->
		<!--<img src="../../assets/img/news/more.png" alt="">-->
		<!--</div>-->
		<!--</div>-->
		<!--</div>-->
		<!--</div>-->
		<!--<div class="news-container-item">-->
		<!--<div class="item-container">-->
		<!--&lt;!&ndash;<div class="container-right" @click="openItem(2)">&ndash;&gt;-->
		<!--&lt;!&ndash;<div style="position: relative">&ndash;&gt;-->
		<!--&lt;!&ndash;<div class="text-container-left">&ndash;&gt;-->
		<!--&lt;!&ndash;<img src="../../components/contact/image/H..png" alt="">&ndash;&gt;-->
		<!--&lt;!&ndash;</div>&ndash;&gt;-->
		<!--&lt;!&ndash;<div class="text-container-right">&ndash;&gt;-->
		<!--&lt;!&ndash;<p>青岛海信史总莅临华视美达考察</p>&ndash;&gt;-->
		<!--&lt;!&ndash;<p style="color: #7f7f7f">2018-12-19</p>&ndash;&gt;-->
		<!--&lt;!&ndash;</div>&ndash;&gt;-->
		<!--&lt;!&ndash;<div class="text-container-down" style="top: 70px">&ndash;&gt;-->
		<!--&lt;!&ndash;<p style="line-height: 25px;">&ndash;&gt;-->
		<!--&lt;!&ndash;2018年12月19日，青岛海信电器营销股份有限公司<br/>史全华先生莅临华视美达郑州公司进行考察，就双方技术<br/>合作达成共识</p>&ndash;&gt;-->
		<!--&lt;!&ndash;</div>&ndash;&gt;-->
		<!--&lt;!&ndash;</div>&ndash;&gt;-->
		<!--&lt;!&ndash;</div>&ndash;&gt;-->
		<!--<div class="container-right center" @click="openItem(3)">-->
		<!--<div style="position: relative">-->
		<!--<div class="text-container-left">-->
		<!--<img src="../../components/contact/image/H..png" alt="">-->
		<!--</div>-->
		<!--<div class="text-container-right">-->
		<!--<p>华视美达亮相CCBN</p>-->
		<!--<p style="color: #7f7f7f">2019-04-25</p>-->
		<!--</div>-->
		<!--<div class="text-container-down" style="top: 70px">-->
		<!--<p style="line-height: 25px;">2019年4月25-27日，华视美达亮相《上海国际酒店<br/>工程设计与用品博览会。</p>-->
		<!--</div>-->
		<!--</div>-->
		<!--</div>-->
		<!--<div class="container-right" @click="openItem(1)">-->
		<!--<div style="position: relative">-->
		<!--<div class="text-container-left">-->
		<!--<img src="../../components/contact/image/H..png" alt="">-->
		<!--</div>-->
		<!--<div class="text-container-right">-->
		<!--<p>2019年新品发布暨渠道伙伴联营大会</p>-->
		<!--<p style="color: #7f7f7f">2019-08-29</p>-->
		<!--</div>-->
		<!--<div class="text-container-down" style="top: 70px">-->
		<!--<p style="line-height: 25px;">2019年8月29日，深圳华视美达信息技术有限公司<br/>召开《2019年新品发布暨合作渠道伙伴联营大会》。-->
		<!--</p>-->
		<!--</div>-->
		<!--</div>-->
		<!--</div>-->
		<!--</div>-->
		<!--</div>-->
		<!--</div>-->
		<div class="news-container">
			<div class="news-item">
				<div class="news">
					<div class="news-wrapper">
						<div class="news-wrapper-img">
							<img src="../../assets/img/news/news4.jpg" alt="">
						</div>
						<div class="news-wrapper-text">
							<p style="color: #eec13f">华视美达亮相Hotel Plus2019</p>
							<p style="color: #7f7f7f">2019-04-25</p>
							<p style="text-indent:2em;line-height: 28px;">
								2019年4月25-27日，华视美达亮相上海国际酒店工程设计与用品博览会，本次华视美达主要展示小美AI场景机器人、华视云朵&点播分成平台以及9款UI和...</p>
						</div>
						<div class="new-more" @click="openItem(4)">
							<img src="../../assets/img/news/more.png" alt="">
						</div>
					</div>
				</div>
				<div class="news">
					<div class="news-wrapper">
						<div class="news-wrapper-img">
							<img src="../../assets/img/news/news1.jpg" alt="">
						</div>
						<div class="news-wrapper-text">
							<p style="color: #eec13f">2019年新品发布暨渠道伙伴联营大会</p>
							<p style="color: #7f7f7f">2019-08-29</p>
							<p style="text-indent:2em;line-height: 28px;">2019年8月29日，深圳华视美达信息技术有限公司
								召开《2019年新品发布暨合作渠道伙伴联营大会》。</p>
						</div>
						<div class="new-more" @click="openItem(1)">
							<img src="../../assets/img/news/more.png" alt="">
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="news-container" style="margin-top: -60px;">
			<div class="news-item">
				<div class="news">
					<div class="news-wrapper" style="width: 45%; float: left;margin-left: 30px;">
						<div class="news-wrapper-img">
							<img src="./img/news_sh.jpg" alt="">
						</div>
						<div class="news-wrapper-text">
							<p style="color: #eec13f">华视美达Hotel Plus2020完美收官</p>
							<p style="color: #7f7f7f">2020-08-14</p>
							<p style="text-indent:2em;line-height: 28px;">
								8月14日，为期3天的上海国际酒店工程设计与用品博览会圆满落幕。华视美达打造的“互娱轻智能”智慧酒店产品系统效果良好，吸引了现场众多客户进行商务洽谈合作。</p>
						</div>
						<div class="new-more" @click="openItem(2)">
							<img src="../../assets/img/news/more.png" alt="">
						</div>
					</div>
				</div>
			</div>
		</div>

		<el-dialog :title="title" :visible.sync="dialogVisible" width="640px">
			<!--新闻1-->
			<div class="new-img" v-if="isNewsOne">
				<p>2019年4月25日-27日，华视美达亮相上海国际酒店工程设计与用品博览会（Hotel Plus），小编带你一秒直达展会现场！</p>
				<div style="text-align: center"><img src="./img/1_1.jpg" alt=""></div>
				<p>本次华视美达主要展示小美AI场景机器人、CIBN&ISO封装、华视云朵&点播分成平台以及9款UI和50多款应用自由搭配组合等，受到行业的同仁们的关注和肯定！</p>
				<p>CIBN版权&终端合作</p>
				<div style="text-align: center"><img src="./img/1_2.jpg" alt=""></div>
				<p>华视云朵&ISO封装</p>
				<div style="text-align: center"><img src="./img/1_3.jpg" alt=""></div>
				<p>华视美投&直播方案</p>
				<div style="text-align: center"><img src="./img/1_4.jpg" alt=""></div>
				<p>客房控制系统</p>
				<div style="text-align: center"><img src="./img/1_5.jpg" alt=""></div>
				<p>云朵统管 专属定制 AI直播 共享点播</p>
				<div style="text-align: center"><img src="./img/1_6.jpg" alt=""></div>
				<p>
					华而视之，美达致简。华视美达专注于酒店行业视讯系统智能化的开发与研究，历经五年市场打磨，已成为酒店行业视讯系统智能化的缔造者！</p>
				<div style="text-align: center"><img src="./img/1_7.jpg" alt=""></div>
				<div style="margin-top: 20px">
				</div>
				<span slot="footer" class="dialog-footer"></span>
			</div>


			<!--新闻2-->
			<div class="new-img" v-if="isNewsTwo">
				<p>华视美达<span class="title-important">2019年新品发布暨渠道伙伴联营大会</span>于2019年8月29日在郑州隆重召开，此次会议重磅发布新品：编播分控一体机，华视云朵2.0系统，房价牌系统，多维投屏网关，遇见-信息发布系统，华视互娱移动端应用系统。</p>
				<div style="text-align: center"><img src="./img/2_1.jpg" alt=""></div>
				<p>华视美达2019年新品发布暨合作渠道伙伴联营大会留念合影</p>
				<div style="text-align: center"><img src="./img/2_2.jpg" alt=""></div>
				<p class="sub-title">华视美达技术总监-刘飞</p>
				<p>发布编播分控一体机，华视云朵2.0，房价牌系统与多维投屏网关</p>
				<div style="text-align: center"><img src="./img/2_3.jpg" alt=""></div>
				<p class="sub-title">华视美达技术总监-刘飞 讲演编播分控一体机</p>
				<p>华视美达编播分控一体机，是针对于相对固定人群需要教培的组织机构，研制开发的视讯播控智能管理设备。产品具备强大的视讯编排能力，可以将多种信源，按照既定设置逻辑要求，进行编播汇聚整理，采用边缘节点指定通道传输的方式，推送分类内容到不同的收视终端，对受训待培人员实施宣化教育。</p>
				<div style="text-align: center"><img src="./img/2_4.jpg" alt=""></div>
				<p class="sub-title">华视云朵2.0系统</p>
				<p>华视云朵V2.0秉承化繁为简、致享管理的理念，为用户带来更为便捷易操的精彩体验。通过本次的更新升级，系统新增模块化交互界面，更为细致的数据统计、汇算、表单导出功能和架构优化处理，提升了系统应用逻辑严谨、易用性和运行流畅度；客户在应用过程中会更为快捷的获知收益率与经营数据模型，增加精准决策支撑元素。除此之外，更新后的系统，设置选项深度精简，用户上手难易度大幅降低，系统的体验度更为高效有趣。</p>
				<div style="text-align: center"><img src="./img/2_5.jpg" alt=""></div>
				<p class="sub-title">房价牌系统</p>
				<p>房价牌系统支持横屏与竖屏，可以实现 ①自动滚动展示 ②展示不同价格体系 ③播放酒店公告活动 ④天气播报 ⑤广告位展示。</p>
				<div style="text-align: center"><img src="./img/2_61.jpg" alt=""></div>
				<p class="sub-title">多维投屏网关</p>
				<p>酒店的WIFI和电视一般是处在不同网段，而且互不相通。手机在这种网络环境下发现不了电视设备，投屏就无从谈起。投屏网关的出现，使跨网投屏问题迎刃而解。只需要从各网段中分别引入一根网线接入投屏网关，投屏网关就可以在它们之间架起桥梁，轻松实现跨网投屏。四大功能：①
					解决WiFi与电视非同一网段 ② 手机无需下载任何APP ③根据房间号自动投屏--0误差 ④ 全面兼容安卓与苹果IOS 。</p>
				<div style="text-align: center"><img src="./img/2_7.jpg" alt=""></div>
				<p class="sub-title">遇见-信息发布系统 周边信息版展示</p>
				<p>遇见信息发布系统-可定制商城信息发布与周边信息展示。</p>
				<p>遇见周边信息展示--景区门票，旅游特产，特色美食，商城购物。本地化信息以LBS为中心，实现信息推广及营销，为酒店带客、创收；</p>
				<div style="text-align: center"><img src="./img/2_8.jpg" alt=""></div>
				<p class="sub-title">遇见-信息发布系统 商城信息版展示</p>
				<div style="text-align: center"><img src="./img/2_9.jpg" alt=""></div>
				<p><span>遇见商城信息展示--</span>增加酒店服务内容及收益。结合酒店自有商城大屏呈现TV商城，更直观更富冲击性把商品呈现给目标人群。除此之外遇见信息发布系统操作也更便捷，可分类管理，多级分享、复制引用，网址转二维码自生成等。减少学习成本。</p>
				<div style="text-align: center"><img src="./img/2_10.jpg" alt=""></div>
				<p class="sub-title">华视美达四川分公司总经理王万安 发布华视互娱移动端应用系统</p>
				<div style="text-align: center"><img src="./img/2_11.jpg" alt=""></div>
				<p>公司自主研发的“华视互娱”酒店客房娱乐系统以重构酒店场景为目的，以酒店视讯、小程序为入口，为酒店提供近场链接服务、远场预定平台；让酒店提供智能化、IP化、场景化的内容运营平台，为用户提供高品质娱乐、消费体验服务，让客房不仅仅只能睡觉。真正实现“住一家店，发现一座城！”让城市IP连接内容；让内容成为流量保障。</p>
				<div style="margin-top: 20px">
					<p>华视美达将继续秉承<span class="title-important">“有技术，创未来”</span>的理念不断创新，持续前进。</p>
				</div>
				<span slot="footer" class="dialog-footer"></span>
			</div>

			<div class="new-img" v-if="isNewsThree">
				<p>8月14日，为期3天的上海国际酒店工程设计与用品博览会圆满落幕。华视美达打造的“互娱轻智能”智慧酒店产品系统效果良好，吸引了现场众多客户进行商务洽谈合作。</p>
				<div style="text-align: center"><img src="./img/sh/1.jpg" alt=""></div>
				<p>客户体验自助入住机</p>
				<div style="text-align: center"><img src="./img/sh/2.jpg" alt=""></div>
				<p>多款ui桌面展示</p>
				<div style="text-align: center"><img src="./img/sh/4.jpg" alt=""></div>
				<p>现场演示智能客控</p>
				<div style="text-align: center"><img src="./img/sh/3.jpg" alt=""></div>
				<p>抖音现场直播</p>
				<div style="text-align: center"><img src="./img/sh/5.jpg" alt=""></div>
				<p>华视美达荣获2020年度“金殿”奖TOP10：最受酒店欢迎智能品牌奖。</p>
				<div style="text-align: center"><img src="./img/sh/6.jpg" alt=""></div>
				<div style="text-align: center;"><img src="./img/sh/8.jpg" alt=""></div>
				<div style="text-align: center;"><img src="./img/sh/7.jpg" alt=""></div>
				<p>
					华视美达感谢本次展会各个行业的专家领导与合作伙伴前来指导交流，华视美达本次展会不仅展示出自身实力，也获得了行业的肯定与认可，感谢大家的莅临与厚爱，在今后的日子里，华视美达定将不忘初心，砥砺前行！</p>
				<div style="margin-top: 20px">
				</div>
				<span slot="footer" class="dialog-footer"></span>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	const news1 = require("../../assets/img/news/news1.jpg")
	const news2 = require("../../assets/img/news/news2.jpg")
	const news3 = require("../../assets/img/news/news3.jpg")
	const news4 = require("../../assets/img/news/news4.jpg")

	const text1 =
		"2019年4月25-27日，华视美达亮相上海国际酒店工程设计与用品博览会，本次华视美达主要展示小美AI场景机器人、华视云朵&点播分成平台以及9款UI和50多款应用自由搭配组合等，受到行业的同仁们的关注和肯定！";
	const text2 = "2018年12月19日，青岛海信电器营销股份有限公司\n" +
		"史全华先生莅临华视美达郑州公司进行考察，就双方技术\n" +
		"合作达成共识"
	const text3 = "2019年4月25-27日，华视美达亮相《上海国际酒店\n" +
		"工程设计与用品博览会。"
	const text4 = "2019年8月29日，深圳华视美达信息技术有限公司\n" +
		"召开《2019年新品发布暨合作渠道伙伴联营大会》。"


	const title1 = "华视美达2019新品发布暨渠道联营大会—新品展示"
	const title2 = "青岛海信史总莅临华视美达考察"
	const title3 = "华视美达亮相CCBN"
	const title4 = "华视美达亮相Hotel Plus2019，有技术，创未来！"

	export default {
		name: "NewsCenter",
		data() {
			return {
				dialogVisible: false,
				title: '提示',
				dialogImg: news1,
				newsText: '2019年4月25-27日，华视美达亮相上海国际酒店工程设计与用品博览会，本次华视美达主要展示小美AI场景机器人、华视云朵&点播分成平台以及9款UI和50多款应用自由搭配组合等，受到行业的同仁们的关注和肯定！',
				isNewsOne: false,
				isNewsTwo: false,
				isNewsThree: false
			};
		},
		methods: {
			openItem(index) {
				this.dialogVisible = true;
				switch (index) {
					case 1:
						this.isNewsOne = false
						this.isNewsTwo = true
						this.isNewsThree = false
						this.newsText = text4
						this.title = title1
						break;
					case 2:
						this.isNewsThree = true
						this.isNewsTwo = false
						this.isNewsOne = false
						this.newsText = text2
						this.title = title2
						break;
					case 3:
						this.dialogImg = news3
						this.newsText = text3
						this.title = title3
						break;
					case 4:
						this.isNewsOne = true
						this.isNewsTwo = false
						this.isNewsThree = false
						this.newsText = text1
						this.title = title4
						break;
				}
			}
		}
	}
</script>

<style scoped>
	.news-banner {
		width: 100%;
		height: 421px;
		background: url("../../assets/img/news/news-banner.png");
		background-size: 100% 100%;
	}

	.news-container {
		width: 1205px;
		margin: 0 auto;
		display: flex;
		height: 700px;
		background-color: #fff;
	}

	.news-container-item {
		flex: 1;
		padding-top: 50px;
	}

	.item-container {
		width: 450px;
		height: 80%;
		margin: 0 auto;
	}

	.item-container img {
		width: 100%;
	}

	.text-container {
		width: 100%;
		position: relative;
		background-color: #f6f6f6;
		height: 267px;
		cursor: pointer;
	}

	.text-container:hover {
		background-color: #fff1da;
	}

	.text-container-left {
		position: absolute;
		left: 40px;
		top: 10px;
		height: 60px;
	}

	.text-container-right {
		position: absolute;
		left: 120px;
		top: 10px;
		height: 60px;
	}

	.text-container-right p {
		margin-top: 6px;
	}

	.text-container-down {
		position: absolute;
		top: 80px;
		left: 40px;
		height: 130px;
	}

	.text-container-down p {
		text-indent: 2em;
		line-height: 28px;
	}

	.container-right {
		width: 450px;
		height: calc((100% - 60px) / 3);
		background-color: #f6f6f6;
		cursor: pointer;
	}

	.container-right:hover {
		background-color: #fff1da;
	}

	.center {
		margin-top: 30px;
		margin-bottom: 30px;
	}

	.icon-more {
		position: absolute;
		bottom: 15px;
		right: 15px;
	}


	/*------------------*/
	.news-container {
		width: 100%;
		height: 350px;
		background-color: rgb(243, 243, 243);
	}

	.news-item {
		width: 1205px;
		margin: 0 auto;
		display: flex;
		height: 100%;
	}

	.news {
		flex: 1;
		padding-top: 50px;
	}

	.news-wrapper {
		position: relative;
		width: 90%;
		height: 80%;
		background-color: #fff;
		margin: 0 auto;
	}

	.news-wrapper-img {
		position: absolute;
		left: 20px;
		top: 40px;
	}

	.news-wrapper-img img {
		width: 233px;
		height: 155px;
	}

	.news-wrapper-text {
		position: absolute;
		left: 270px;
		top: 40px;
	}

	.new-more {
		position: absolute;
		bottom: 10px;
		right: 10px;
		cursor: pointer;
	}

	.new-img {
		height: 600px;
		overflow: auto;
	}

	.new-img img {
		width: 100%;
	}

	.new-img p {
		font-size: 14px;
		letter-spacing: 2px;
		margin-top: 15px;
		margin-bottom: 10px;
		line-height: 25px;
	}

	.new-img p>span {
		font-weight: bold;
	}

	.sub-title {
		text-align: center;
		font-size: 10px !important;
		color: rgb(182, 182, 182);
	}

	.title-important {
		color: rgb(255, 169, 59);
		font-weight: normal !important;
	}
</style>
